<template>
  <div class="container" >
    <!--<van-nav-bar-->
        <!--title="收银台"-->
        <!--left-arrow-->
        <!--@click-left="onClickLeft"-->
    <!--&gt;</van-nav-bar>-->
    <div class="cashier-money">
      <span class="fs-18"> ¥</span>{{ totalMoney }}
    </div>
    <div class="cashier-main">
      <div class="flex-rsc section1" v-if="payPhone">
        <div class="fs-14 fw-500">会员卡支付：</div>
        <div class="fs-16">{{payPhone}}</div>
      </div>
      <div class="flex-rbc section1" v-else>
        <div class="flex-rac">
          <div class="fs-14 fw-500 flex-shrink0">会员卡支付：</div>
          <div class="discounts">
            <van-field :border="noBorder" type="tel" v-model="phone" placeholder="输入会员卡手机号" ></van-field>
          </div>
        </div>
        <div class="recharge flex-shrink0" @click="getCode">查询会员卡</div>
      </div>
      <van-checkbox-group class="checkbox-group" v-model="cardIds" checked-color="#FA4E26" >
        <van-cell-group>
          <van-cell
              v-for="(item, index) in usableCards"
              clickable
              :key="index"
              @click="toggle(index, item)"
              style="flex: auto"
          >
            <div slot="title" class="checkbox-tit" style="flex: auto" >
              <div class="flex-1">{{item.typeStr}}</div>
              <div class="flex-1 flex-rsc fs-12" v-if="item.type === 'TIME_CARD'">剩余{{item.balanceNum}}次</div>
              <div class="flex-1 flex-rsc fs-12" v-if="item.type === 'DISCOUNT_STORE_CARD'">
                <span>余额: </span> <span>{{item.oldAmountStr}}元</span>
                <span v-if="item.discount > 0 && item.discount < 100" style="padding-left: 3px"> {{item.discount / 10}} 折</span>
              </div>
            </div>
            <div class="flex-rec" v-if="item.type === 'TIME_CARD'">
              <van-checkbox slot="right-icon" :name="item.cardId" ref="checkboxes" :disabled="!item.select && (balance === 0 || item.balanceNum === 0)"></van-checkbox>
            </div>
            <div class="flex-rec" v-if="item.type === 'DISCOUNT_STORE_CARD'">
              <van-checkbox slot="right-icon" :name="item.cardId" ref="checkboxes" :disabled="!item.select && (balance === 0 || item.oldAmount === 0)"></van-checkbox>
            </div>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <div class="coupon-main">
        <div class="van-cell-coupon" @click="showCouponFn('discountCouponModal')" >
          <van-cell  >
            <div class="flex-rsc" slot="title">
              <div class="clr-0 fs-13">优惠券:</div>
              <div class="coupon-msg clr-red fs-12"  v-if="discountCouponObj && discountCouponObj.amountStr === maxMoney" >已选择最大优惠劵</div>
            </div>
            <div class="flex-rec" v-if="discountCoupon && discountCoupon.length > 0">
              <div class="clr-gary fs-13" v-if="discountCouponObj && discountCouponObj.amountStr" >优惠：-¥{{discountCouponObj.amountStr}}</div>
              <div v-else>{{discountCoupon.length}}张</div>
              <van-icon name="arrow"></van-icon>
            </div>
            <div class="flex-rec fs-12 clr-9" v-else>暂无可用优惠劵<van-icon name="arrow"></van-icon></div>
          </van-cell>
        </div>
        <div class="van-cell-coupon"  @click="showCouponFn('cashCouponModal')" >
          <van-cell >
            <div class="flex-rsc" slot="title">
              <div class="clr-0 fs-13">代金劵:</div>
            </div>
            <div class="flex-rec" v-if="cashCoupon && cashCoupon.length > 0">
              <div class="clr-gary fs-13" v-if="setCashCouponArr && setCashCouponArr.length > 0">
                <span>已选{{setCashCouponArr.length}}张，</span>
                减免 -¥{{cashCouponMoney}}</div>
              <div v-else>{{cashCoupon.length}}张</div>
              <van-icon name="arrow"></van-icon>
            </div>
            <div class="flex-rec fs-12 clr-9" v-else>暂无可用代金劵<van-icon name="arrow"></van-icon></div>
          </van-cell>
        </div>
        <div class="van-cell-coupon"  @click="showCouponFn('skuCouponModal')">
          <van-cell :border="isBorder">
            <div class="flex-rsc" slot="title">
              <div class="clr-0 fs-13">项目劵:</div>
            </div>
            <div class="flex-rec" v-if="skuCoupon && skuCoupon.length > 0">
              <div class="clr-gary fs-13" v-if="skuCouponObj && skuCouponObj.amountStr">优惠：-¥{{skuCouponObj.amountStr}}</div>
              <div v-else>{{skuCoupon.length}}张</div>
              <van-icon name="arrow"></van-icon>
            </div>
            <div class="flex-rec fs-12 clr-9" v-else>暂无可用项目劵<van-icon name="arrow"></van-icon></div>
          </van-cell>
        </div>
      </div>
      <div class="total-money">
        <van-cell-group >
          <van-cell title="总金额" :value="'¥'+ totalMoney"></van-cell>
        </van-cell-group>
        <div class="discounts-info">
          <van-cell-group v-if="skuSale">
            <van-cell title="项目劵抵扣" :value="'-¥' + skuSale"></van-cell>
          </van-cell-group>
          <van-cell-group class="discounts-top" v-if="skuCardSale">
            <van-cell title="次卡抵扣" :value="'-¥' + skuCardSale"></van-cell>
          </van-cell-group>
          <van-cell-group v-if="disSale">
            <van-cell title="优惠劵" :value="'-¥' + disSale"></van-cell>
          </van-cell-group>
          <van-cell-group v-if="cashSale">
            <van-cell title="代金劵" :value="'-¥' + cashSale"></van-cell>
          </van-cell-group>
          <van-cell-group v-if="disCardSale">
            <van-cell title="会员卡支付" :value="'-¥' + disCardSale"></van-cell>
          </van-cell-group>
          <van-cell-group v-if="disCardZKSale">
            <van-cell title="会员卡折扣" :value="'-¥' + disCardZKSale"></van-cell>
          </van-cell-group>
          <van-cell-group>
            <van-cell>
              <div slot="title" class="fs-16 fw-500">
                待支付金额
              </div>
              <div class="fs-14 fw-500 clr-red">
                ¥ {{cashierInfo.balance || totalMoney}}
              </div>
            </van-cell>
          </van-cell-group>
        </div>
      </div>
      <div class="bottom-bar-placeholder"></div>
      <div class="bottom-bar-placeholder"></div>
      <div class="btn-box">
        <div class="button-default" :class="isApp === 'isWeixin' ? 'wx-button-primary' : 'zfb-button-primary'" @click="payInfo">付款 ¥ {{ balance }}</div>
      </div>
    </div>
    <modal :visible="showModal" @ok="seachCard" @hideModal="hideModal" title="手机验证码">
      <div class="flex-rbc code-box">
        <van-field  class="code-input" :border="noBorder" v-model="code" maxlength="4" type="digit" placeholder="输入验证码" ></van-field>
        <div @click="getCode" class="getCodeBtn" :class="{'disable': timeCount > 0}">{{timeCount > 0 ? timeCount + 's' : '获取验证码'}}</div>
      </div>
    </modal>
    
    <discountCouponModal :setCashCouponArr='setCashCouponArr' :couponList="discountCoupon" :UnDiscountCoupon="UnDiscountCoupon" :setCouponId="setDisCouponId" :showCoupon="discountCouponModal" @closePopup="closePopup" @discountPopup="discountPopup"></discountCouponModal>
    <skuCouponModal :couponList="skuCoupon" :UnSkuCoupon="UnSkuCoupon" :setCouponId="setSKuCouponId" :showCoupon="skuModal" @closePopup="closePopup" @skuPopup="skuPopup"></skuCouponModal>
    <cashCouponModal :discountCouponObj="discountCouponObj" :couponList="cashCoupon" :UnCashCoupon="UnCashCoupon" :setCouponIds="setCashCouponIds" :showCoupon="cashCouponModal" @closePopup="closePopup" @cashPopup="cashPopup" :cashCouponM="cashCouponM"></cashCouponModal>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import WXPay from '../../util/wxpay'
  import discountCouponModal from '@/components/coupon/discountCoupon'
  import skuCouponModal from '@/components/coupon/skuCoupon'
  import cashCouponModal from '@/components/coupon/cashCoupon'
  import modal from '@/components/common/modal'
  export default {
    name: 'commentCashier',
    data () {
      return {
        totalMoney: '', // 总金额
        couponMoney: '',
        isBorder: false,
        orderNo: '',
        usableCards: [], // 会员卡
        usableCoupons: [], // 优惠劵
        discountCoupon: [], // 满减劵
        discountCouponObj: {},
        skuCouponObj: {},
        cashCouponObj: {},
        cashCoupon: [], // 代金劵
        skuCoupon: [], // 项目劵
        skuModal: false,
        discountCouponModal: false,
        cashCouponModal: false,
        maxMoney: '',
        cashierInfo: {},
        paymentDetails: [],
        loading: false,
        code: '',
        timeCount: 0,
        timer: null,
        phone: '',
        amount: '',
        storeIdStr: '',
        showModal: false,
        setCashCouponIds: [],
        setSKuCouponId: '',
        setDisCouponId: '',
        setCashCouponArr: [], // 选中代金劵数组
        cashCouponMoney: 0, // 代金劵总价格
        cardIds: [],
        cardMoney: '',
        cardItem: [],
        cashItem: [],
        couponItem: [],
        cardSale: 0,
        couponSale: 0,
        UnDiscountCoupon: [],
        UnCashCoupon: [],
        UnSkuCoupon: [],
        cardPackage: [],
        checkIndex: -1,
        storeName: '',
        cardPayMoney: 0,
        skuCardSale: 0,
        disCardSale: 0,
        disSale: 0,
        cashSale: 0,
        skuSale: 0,
        balance: 0,
        disCardZKSale: 0,
        payPhone: '',
        loading: false,
        inited: false,
        couponIds: [],
        isOpenCard: 0,
        cashCouponM: 0,
        noBorder: false
      }
    },
    computed: {
      ...mapState(['isApp', 'openId'])
    },
    mounted () {
      this.inited = false
      console.log('this.$store.state.orderCashier', this.$store.state.orderCashier)
      const { cardIds = [], couponIds = [], orderNo = '', phone = '' } = this.$store.state.orderCashier
      console.log('cardIds', cardIds)
      console.log('couponIds', couponIds)
      console.log('orderNo', orderNo)
      console.log('phone', phone)
      this.payPhone = phone
      this.cardIds = cardIds
      this.couponIds = couponIds
      this.orderNo = orderNo
      this.offerPayCashDesk()
    },
    components: {
      skuCouponModal,
      discountCouponModal,
      cashCouponModal,
      modal
    },
    methods: {
      getCashierInfo () {
        const { orderNo = '', usableCards = [], usableCoupons = {}, unusableCoupons = {}, amount = 0, balance = 0, giftCoupon = [], itemPaymentDetails = [], cardPackage = [], storeName, autoOrderStr = '' } = this.cashierInfo
        this.storeName = storeName
        this.cardPackage = cardPackage
        this.$store.commit('giftCoupon', giftCoupon)
        this.$store.commit('autoOrderStr', autoOrderStr)
        this.orderNo = orderNo
        this.usableCoupons = usableCoupons
        this.totalMoney = amount
        this.balance = Number(balance)
        console.log('balance', this.balance)
        const { DISCOUNT_COUPON = [], CASH_COUPON = [], SKU_COUPON = [] } = usableCoupons
        // 优惠劵
        this.setDisCouponId = ''
        this.maxMoney = ''
        this.discountCouponObj = {}
        this.discountCoupon = DISCOUNT_COUPON
        this.couponMoney = ''
        this.setDisCouponId = ''
        this.discountCouponObj = {}
        let discountAmountStr = 0
        this.discountCoupon.forEach((item, index) => {
          item.couponId = item.couponId.toString()
          if (index === 0) {
            this.maxMoney = item.maxAmountStr
          }
          if (item.select) {
            this.couponMoney = item.maxAmountStr
            this.setDisCouponId = item.couponId.toString()
            this.discountCouponObj = item
            discountAmountStr = Number(item.amountStr)
          }
        })
        // 代金劵
        this.cashCoupon = CASH_COUPON
        this.cashCoupon.forEach(item => {
          item.couponId = item.couponId.toString()
        })
        this.setCashCouponArr = this.cashCoupon.filter(item => item.select)
        this.setCashCouponArr.forEach(item => {
          this.cashCouponMoney += Number(item.amountStr)
          this.setCashCouponIds.push(item.couponId)
        })
        if (this.balance > 0) {
          this.cashCouponM = this.cashCouponMoney > 0 ? this.balance + this.cashCouponMoney : this.balance + discountAmountStr
        } else {
          this.cashCouponM = this.cashCouponMoney > 0 ? this.cashCouponMoney : discountAmountStr
        }
        console.log('cashCouponM', this.cashCouponM)
        // 项目劵
        this.skuCoupon = SKU_COUPON
        this.usableCards = usableCards
        this.cardIds = []
        this.skuCouponObj = {}
        this.usableCards.forEach(item => {
          if (item.select) {
            this.cardIds.push(item.cardId)
          }
        })
        this.skuCoupon.forEach(item => {
          item.couponId = item.couponId.toString()
          if (item.select) {
            this.skuCouponObj = item
            this.setSKuCouponId = item.couponId.toString()
          }
        })
        const { DISCOUNT_COUPON: UNDISCOUNT_COUPON, CASH_COUPON: UNCASH_COUPON, SKU_COUPON: UNSKU_COUPON } = unusableCoupons
        this.UnDiscountCoupon = UNDISCOUNT_COUPON
        this.UnCashCoupon = UNCASH_COUPON
        this.UnSkuCoupon = UNSKU_COUPON
        const { cardItem = [], couponItem = [] } = itemPaymentDetails
        // this.cardItem = cardItem
        /*
        SKU_CARD(3, "次卡")
        DISCOUNT_CARD(4, "储值折扣卡")
        */
        let skuCardSale = 0
        let disCardSale = 0
        let disCardZKSale = 0
        cardItem.forEach(item => {
          if (item.payTypeEnum === 'SKU_CARD') { // 次卡
            skuCardSale += item.discountAmount * 100
          }
          if (item.payTypeEnum === 'DISCOUNT_CARD') { // 储值折扣卡
            disCardSale += item.discountAmount * 100
          }
          if (item.payTypeEnum === 'DISCOUNT_CARD_ZK') { // 储值折扣卡
            disCardZKSale += item.discountAmount * 100
          }
        })
        this.skuCardSale = skuCardSale / 100
        this.disCardSale = disCardSale / 100
        this.disCardZKSale = disCardZKSale / 100
        console.log('cardSale', this.cardSale)
        // this.cashItem = cashItem
        /*
       SKU_COUPON(5, "项目券")
       CASH_COUPON(6, "代金券")
       DISCOUNT_COUPON(7, "满减券")
       */
        let disSale = 0
        let cashSale = 0
        let skuSale = 0
        couponItem.forEach(item => {
          if (item.payTypeEnum === 'DISCOUNT_COUPON') { // 满减劵
            disSale += item.discountAmount * 100
          }
          if (item.payTypeEnum === 'CASH_COUPON') { // 代金劵
            cashSale += item.discountAmount * 100
          }
          if (item.payTypeEnum === 'SKU_COUPON') { // 项目
            skuSale += item.discountAmount * 100
          }
        })
        this.disSale = disSale / 100
        this.cashSale = cashSale / 100
        this.skuSale = skuSale / 100
      },
      offerPayCashDesk () {
        const { storeIdStr = '', orderNo, cardIds, couponIds, openId } = this
        let payChancel
        if (this.isApp === 'isAlipay') {
          payChancel = 2
        } else if (this.isApp === 'isWeixin') {
          payChancel = 1
        }
        console.log('cashDeskApi---couponIds:', couponIds)
        this.$api.pay.offerPayDeskApi({
          orderNo,
          couponIds,
          storeIdStr,
          cardIds,
          openId,
          payChancel
        }).then(res => {
          console.log('cashDesk', res)
          this.closePopup()
          this.hideModal()
          if (res.errCode === '0') {
            this.cashCouponMoney = 0
            this.cashierInfo = {}
            this.cashierInfo = res.data
            this.getCashierInfo()
          } else {
            this.$toast(res.errMsg)
          }
        })
      },
      seachCard () {
        const { storeIdStr = '', orderNo, cardIds, couponIds, openId, phone, code, payPhone } = this
        let payChancel
        if (this.isApp === 'isAlipay') {
          payChancel = 2
        } else if (this.isApp === 'isWeixin') {
          payChancel = 1
        }
        console.log('cashDeskApi---couponIds:', couponIds)
        console.log('cashDeskApi---code:', code)
        this.$api.pay.offerPayDeskApi({
          orderNo,
          couponIds,
          storeIdStr,
          cardIds,
          openId,
          payChancel,
          phone,
          code
        }).then(res => {
          console.log('cashDesk', res)
          this.closePopup()
          this.code = ''
          this.showModal = false
          if (res.errCode === '0') {
            this.cashCouponMoney = 0
            this.cashierInfo = {}
            this.cashierInfo = res.data
            const {usableCards = []} = res.data
            if (!payPhone) {
              if (usableCards.length > 0) {
                this.payPhone = res.data.phone
              } else {
                this.payPhone = ''
                if (phone) {
                  this.$toast('该手机号没有办理会员卡，请确认会员手机号!')
                }
              }
            }
            this.getCashierInfo()
          } else {
            this.$toast(res.errMsg)
          }
        })
      },
      payInfo () {
        const { orderNo, openId = '', loading } = this
        let payChancel
        if (this.isApp === 'isAlipay') {
          payChancel = 2
        } else if (this.isApp === 'isWeixin') {
          payChancel = 1
        }
        if (loading) return
        this.loading = true
        this.$api.pay.payInfoApi({
          orderNo,
          payChancel,
          openId
        }).then(res => {
          console.log(res);
          if (res.errCode === '0') {
            this.loading = false
            const { payType } = res.data
            console.log('payInfoApi', res.data)
            if (payType === 'wxPay') { // 微信支付
              console.log('isApp', this.isApp)
              if (this.isApp === 'isAlipay') {
                this.aliPay(res.data)
              } else if (this.isApp === 'isWeixin') {
                this.callWXPay(res.data)
              }
            } else if (payType === 'cardPay') {
              this.paySuccess()
            } else if (payType === 'couponPay') {
              this.paySuccess()
            }
          } else {
            this.loading = false
            this.$toast(res.errMsg)
          }
        });
      },
      aliPay (obj) {
        ap.tradePay({
          tradeNO: obj.aliTradeNo
        }, (res) => {
          console.log('aliPay', res)
          if (res.resultCode === '9000') {
            this.paySuccess()
          }
        });
      },
      callWXPay (obj) {
        function payCallback(payResult) {
      
          // 客户端，支付成功
          if (payResult === 'ok') {
            console.log('支付成功')
            // this.getPrepayOrderStatus();
            this.paySuccess()
            // 客户端，用户取消
          } else if (payResult === 'cancel') {
            this.$toast('支付失败，请稍后重试')
            // 客户端，其他错误导致支付失败
          } else {
            this.$toast('支付失败，请稍后重试')
          }
        }
        WXPay.callWXPay(obj, payCallback.bind(this))
      },
      showCouponFn (modal) {
        const { discountCoupon = [], UnDiscountCoupon = [], cashCoupon = [], UnCashCoupon = [], skuCoupon = [], UnSkuCoupon = [] } = this
        if (modal === 'discountCouponModal') {
          if (discountCoupon.length > 0 || UnDiscountCoupon.length > 0) {
            this.discountCouponModal = true
          }
        } else if (modal === 'cashCouponModal') {
          if (cashCoupon.length > 0 || UnCashCoupon.length > 0) {
            this.cashCouponModal = true
          }
        } else if (modal === 'skuCouponModal') {
          if (skuCoupon.length > 0 || UnSkuCoupon.length > 0) {
            this.skuCouponModal = true
          }
        }
      },
      getCouponIds () {
        const { setDisCouponId = '', setCashCouponIds = [], setSKuCouponId = '' } = this
        let disArr = [setDisCouponId]
        let skuArr = [setSKuCouponId]
        let allArr = [...disArr, ...setCashCouponIds, ...skuArr]
        this.couponIds = allArr.filter(item => item !== '')
        this.offerPayCashDesk()
      },
      discountPopup (e) {
        console.log('discountPopup: e', e)
        this.discountCouponObj = e
        this.setDisCouponId = e.couponId ? e.couponId.toString() : ''
        this.setCashCouponIds = []
        this.setCashCouponArr = []
        this.getCouponIds()
      },
      cashPopup (e) {
        console.log('cashPopup: e', e)
        console.log('setCashCouponArr: e', this.cashCoupon)
        this.setCashCouponIds = e
        this.discountCouponObj = {}
        this.setDisCouponId = ''
        this.getCouponIds()
      },
      skuPopup (e) {
        console.log('skuPopup: e', e)
        this.setSKuCouponId = e.couponId ? e.couponId.toString() : ''
        this.getCouponIds()
      },
      closePopup () {
        this.discountCouponModal = false
        this.skuModal = false
        this.cashCouponModal = false
      },
      getCode () {
        const {phone, timeCount} = this
        if (!phone) return this.$toast('手机号不能为空！')
        if (!/^1\d{10}$/.test(phone)) {
          this.$toast('手机号格式错误!')
          return
        }
        if (timeCount > 0) {
          this.showModal = true
          return
        }
        this.$api.pay.getCodeApi({
          phone
        }).then(res => {
          console.log(res)
          if (res.errCode === '0') {
            this.showModal = true
            console.log('', res.data)
            this.startCountDown()
          } else {
            this.$toast(res.errMsg)
          }
        })
      },
      startCountDown () {
        this.timeCount = 120
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          if (this.timeCount > 0) {
            this.timeCount--
          } else {
            clearInterval(this.timer)
          }
        }, 1000)
      },
      hideModal () {
        this.code = ''
        this.showModal = false
      },
      toggle(index, item) {
        if (item.type === 'TIME_CARD' && !item.select && (this.balance === 0 || item.balanceNum === 0)) {
          return
        }
        if (item.type === 'DISCOUNT_STORE_CARD' && !item.select && (this.balance === 0 || item.oldAmount === 0)) {
          return
        }
        let arr = []
        this.usableCards[index].select = !this.usableCards[index].select
        this.usableCards.forEach(card => {
          if (card.select) {
            arr.push(card.cardId)
          }
        })
        this.cardIds = arr
        this.offerPayCashDesk()
      },
      paySuccess () {
        const {orderNo} = this
        this.$router.replace({ path: '/paySuccess', query: { orderNo } })
      },
      onClickLeft() {
        this.$router.go(-1)
      }
    }
  }
</script>

<style scoped lang="stylus">
  .container
    min-height 100vh
    background-size cover
    .cashier-money
      padding 60px 0 30px
      font-size 36px
      font-weight 500
      text-align center
    .cashier-main
      /*width 90vw*/
      /*margin 0 auto*/
      .section1
        padding 10px 16px
        background #fff
        margin-bottom 17px
        color $grayColor
        font-size 16px
        .recharge
          padding 4px 8px
          color #fff
          font-size 12px
          text-align center
          border-radius 6px
          background:linear-gradient(0deg,#FA4E26,#F94E28);
        .discounts
          background #fff
          font-size 14px
          color #111111
      .checkbox-group
        margin-bottom 10px
        background #fff
        >>>.van-cell__title
          width 70% !important
          flex: auto
        .checkbox-tit
          width 85%
          display flex
        .checkbox-babel
          padding 10px 16px
          font-size 16px
          color #232323
          &:not(:last-child)
            border-bottom 1px solid $borderColor
      .coupon-main
        margin-bottom  10px
      .discounts-item
        background #fff
        padding 8px 20px
        color $grayColor
        &:not(:last-child)
          border-bottom 1px solid $borderColor
        .discounts-item-box
          width 20%
        .discounts-item-box2
          width 40%
  .btn-box
    position fixed
    bottom 0
    left 0
    right 0
    padding 20px
    background #fff
  .code-box
    padding 10px 20px
  .getCodeBtn
    width 100px
    height 30px
    line-height 30px
    color #fff
    font-size 14px
    text-align center
    border-radius 6px
    background:linear-gradient(0deg,#FA4E26,#F94E28);
    &.disable
      background: rgba(#FA4E26, 0.5)
  >>>.van-cell__title
    font-weight 500
</style>
